var _templateObject = _taggedTemplateLiteralLoose(['\n  display: flex;\n  width: 100%;\n  background-color: transparent;\n'], ['\n  display: flex;\n  width: 100%;\n  background-color: transparent;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n'], ['\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { map } from 'ramda';
import { FbIcon, GIcon, InIcon, TwitterIcon, YoutubeIcon, InstagramIcon, WebsiteIcon } from '../Icons';

var SocialBox = styled.div(_templateObject);

export var Link = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer'
})(_templateObject2);

export var socialIcons = {
  facebook: function facebook(link, id) {
    return React.createElement(
      Link,
      { key: id, href: link },
      React.createElement(FbIcon, null)
    );
  },
  google: function google(link, id) {
    return React.createElement(
      Link,
      { key: id, href: link },
      React.createElement(GIcon, null)
    );
  },
  linkedin: function linkedin(link, id) {
    return React.createElement(
      Link,
      { key: id, href: link },
      React.createElement(InIcon, null)
    );
  },
  twitter: function twitter(link, id) {
    return React.createElement(
      Link,
      { key: id, href: link },
      React.createElement(TwitterIcon, null)
    );
  },
  youtube: function youtube(link, id) {
    return React.createElement(
      Link,
      { key: id, href: link },
      React.createElement(YoutubeIcon, null)
    );
  },
  instagram: function instagram(link, id) {
    return React.createElement(
      Link,
      { key: id, href: link },
      React.createElement(InstagramIcon, null)
    );
  },
  website: function website(link, id) {
    return React.createElement(
      Link,
      { key: id, href: link },
      React.createElement(WebsiteIcon, null)
    );
  }
};

export default (function (_ref) {
  var networks = _ref.networks;
  return React.createElement(
    SocialBox,
    null,
    map(function (_ref2) {
      var name = _ref2.name,
          link = _ref2.link,
          id = _ref2.id;
      return socialIcons[name](link, id);
    }, networks)
  );
});